/* Contact form (snippets/aof-contact-router.liquid). Works with no script at
   all - every field is visible and sends. This only does three small things:
   shows the order-number box for the topics that need one, preselects the topic
   from ?topic=, and carries ?product= from a product page into the message. */
(() => {
  document.querySelectorAll('[data-aof-contact-router]').forEach((router) => {
    const topic = router.querySelector('[data-contact-topic]');
    const orderField = router.querySelector('[data-contact-order]');
    const orderInput = orderField?.querySelector('input');
    if (!topic) return;

    const syncOrderField = () => {
      const needsOrder = !!topic.selectedOptions[0]?.hasAttribute('data-needs-order');
      if (!orderField || !orderInput) return;
      orderField.hidden = !needsOrder;
      orderInput.disabled = !needsOrder;
    };
    topic.addEventListener('change', syncOrderField);

    const params = new URLSearchParams(window.location.search);

    // Old links used the nine-tile keys; they still land on the nearest topic.
    const aliases = {
      order: 'order', delivery: 'order', order_delivery: 'order',
      return: 'return', returns_changes: 'return', fault: 'return', fault_warranty: 'return',
      product: 'product', compare: 'product', product_advice: 'product',
      stock: 'stock', stock_sourcing: 'stock',
      website: 'website', website_payment: 'website',
      other: 'other', shop: 'other', shop_information: 'other', event: 'other', event_competition: 'other'
    };
    const wanted = aliases[params.get('topic')];
    const match = wanted && topic.querySelector(`option[data-topic="${wanted}"]`);
    if (match) match.selected = true;
    syncOrderField();

    const productName = params.get('product');
    if (productName) {
      const productUrl = params.get('product_url');
      const about = router.querySelector('[data-contact-product]');
      const nameEl = router.querySelector('[data-contact-product-name]');
      const value = router.querySelector('[data-contact-product-value]');
      if (value) value.value = [productName, productUrl].filter(Boolean).join(' | ');
      if (nameEl) nameEl.textContent = productName;
      if (about) about.hidden = false;
    }
  });
})();
